/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_comment$ref } from "./CommentContainer_comment.graphql";
import { CommentContainer_story$ref } from "./CommentContainer_story.graphql";
import { CreateCommentMutation_story$ref } from "./CreateCommentMutation_story.graphql";
import { CreateCommentReplyMutation_story$ref } from "./CreateCommentReplyMutation_story.graphql";
import { IgnoredTombstoneOrHideContainer_comment$ref } from "./IgnoredTombstoneOrHideContainer_comment.graphql";
import { PostCommentFormContainer_story$ref } from "./PostCommentFormContainer_story.graphql";
import { ReplyListContainer1_comment$ref } from "./ReplyListContainer1_comment.graphql";
import { ReplyListContainer1_story$ref } from "./ReplyListContainer1_story.graphql";
declare const _UnansweredCommentsTabContainer_story$ref: unique symbol;
export type UnansweredCommentsTabContainer_story$ref = typeof _UnansweredCommentsTabContainer_story$ref;
export type UnansweredCommentsTabContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
    };
    readonly comments: {
        readonly viewNewEdges: ReadonlyArray<{
            readonly cursor: unknown;
        }> | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly enteredLive: boolean | null;
                readonly id: string;
                readonly " $fragmentRefs": CommentContainer_comment$ref & ReplyListContainer1_comment$ref & IgnoredTombstoneOrHideContainer_comment$ref;
            };
        }>;
    };
    readonly " $fragmentRefs": PostCommentFormContainer_story$ref & CommentContainer_story$ref & ReplyListContainer1_story$ref & CreateCommentReplyMutation_story$ref & CreateCommentMutation_story$ref;
    readonly " $refType": UnansweredCommentsTabContainer_story$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "UnansweredCommentsTabContainer_story",
        "type": "Story",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "comments"
                    ]
                }
            ]
        },
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "count",
                "type": "Int!",
                "defaultValue": 20
            },
            {
                "kind": "LocalArgument",
                "name": "cursor",
                "type": "Cursor",
                "defaultValue": null
            },
            {
                "kind": "LocalArgument",
                "name": "orderBy",
                "type": "COMMENT_SORT!",
                "defaultValue": "CREATED_AT_DESC"
            },
            {
                "kind": "LocalArgument",
                "name": "tag",
                "type": "TAG!",
                "defaultValue": "UNANSWERED"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isClosed",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "settings",
                "storageKey": null,
                "args": null,
                "concreteType": "StorySettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "live",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LiveConfiguration",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "enabled",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": "comments",
                "name": "__UnansweredStream_comments_connection",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    },
                    {
                        "kind": "Variable",
                        "name": "tag",
                        "variableName": "tag"
                    }
                ],
                "concreteType": "CommentsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Comment",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "__typename",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "CommentContainer_comment",
                                        "args": null
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ReplyListContainer1_comment",
                                        "args": null
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "IgnoredTombstoneOrHideContainer_comment",
                                        "args": null
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "enteredLive",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    }
                                ]
                            },
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "viewNewEdges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "plural": true,
                                "selections": [
                                    (v1 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "PostCommentFormContainer_story",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CommentContainer_story",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "ReplyListContainer1_story",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CreateCommentReplyMutation_story",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "CreateCommentMutation_story",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '1423f88b774ccca5375193fd17d2142d';
export default node;
